import React, { ReactNode, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { OperationProvider } from "../../../../../contexts/OperationContext";
import { selectTenantId } from "../../../../../util/store/selectors";
import { getStore } from '../../../../../util/store/store';
import { ILevelByOp } from "../../../../../util/varibles/interface";
import { selectPlan } from '../../../constants';
import { planOpActions } from '../../../reducer';
import Operation from "./Operation";

interface IProps {
    vesselIndex: number
    width: number
    level?: ILevelByOp
}

const Operations: React.FC<IProps> = ({ level = {}, width, vesselIndex, ...args }) => {
    const operations = useSelector(selectPlan.ops);
    const userTenantId = useMemo(() => selectTenantId(getStore()), [])
    const dispatch = useDispatch();

    return <>
        {Object.keys(level).reduce((rs: ReactNode[], key) => {
            const item = operations[key] || {};

            if (!item?.operation)
                return rs;

            const { id, tenant_id } = item.operation || {};
            const isOwn = tenant_id === userTenantId;
            return [...rs, <OperationProvider
                key={item.operation.id}
                isOwn={isOwn}
                isDrag={isOwn}
                data={item}
                vesselIndex={vesselIndex}
                level={level[id]}
                width={width}
                getVessels={state => state.planOperation.vessels}
                getOps={state => state.planOperation.operations}
                updateOp={value => dispatch(planOpActions.updateOps({ update: { [id]: { ...item, ...value } } }))}
            >
                <Operation {...args} data={item} isOwn={isOwn} />
            </OperationProvider>]
        }, [])}
    </>;
};

export default Operations;
